import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Printer } from 'src/app/domain/printer/printer';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-printer-dialog',
  templateUrl: './delete-printer-dialog.component.html',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule
  ],
  styleUrls: ['./delete-printer-dialog.component.css']
})
export class DeletePrinterDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeletePrinterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Printer) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
